import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./battle-animations.css";

import store from "./init/store";
import { Provider } from "react-redux";
import {getFirebaseConfig} from "./firebase-env-setup";
import {initGoogleAnalytics} from './init-google-analytics'

/* Initialize firebase! */
window.firebase.initializeApp(getFirebaseConfig());

/* Initialize Google Analytics! */
initGoogleAnalytics();

/* Absolute root of the app */
class RootComponent extends React.Component {
  render() {
    return (
      <Provider store={this.props.store}>
        <App />
      </Provider>
    );
  }
}
ReactDOM.render(
  <RootComponent store={store} />,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js